export type Bbox2d = [number, number, number, number];

/**
 * Returns a SW -> NE box given any two corners.
 *
 * Note: this doesn't account for dateline crossing.
 */
export function normaliseBbox(box: Bbox2d): Bbox2d {
  let SWX: number, SWY: number, NEX: number, NEY: number;

  // X
  if (box[0] < box[2]) {
    SWX = box[0];
    NEX = box[2];
  } else {
    SWX = box[2];
    NEX = box[0];
  }

  // Y
  if (box[1] < box[3]) {
    SWY = box[1];
    NEY = box[3];
  } else {
    SWY = box[3];
    NEY = box[1];
  }

  return [SWX, SWY, NEX, NEY];
}

/**
 * Returns the smallest SW -> NE box that contains both input boxes.
 * Inputs are expected as [minX, minY, maxX, maxY] (SW -> NE).
 * Does not account for dateline crossing.
 */
export function unionBbox(a: Bbox2d, b: Bbox2d): Bbox2d {
  return [
    Math.min(a[0], b[0]),
    Math.min(a[1], b[1]),
    Math.max(a[2], b[2]),
    Math.max(a[3], b[3]),
  ];
}
